import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// import { Message } from 'element-ui'
// import { getToken } from '@/utils/auth'
import { constantRouterMap } from './routerMap'

Vue.use(Router)

NProgress.configure({ showSpinner: false })

const router = new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
// 白名单
const whiteList = ['/login', '/home'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  console.log(`before: from:${from.path}, to:${to.path}`)
  NProgress.start()
  if (to.matched.length === 0) {
    // 当前没有匹配到路由 进入404页面
    next('/404')
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      // if (getToken()) {
      //   next()
      // } else {
      //   if (from.path !== '/home') {
      //     Message.warning('未登录,无法访问目标页面!')
      //     next('/home')
      //   } else {
      //     router.app.$bus.$emit('openLogin', { path: to.path })
      //   }
      //   NProgress.done()
      // }
      next()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
